import TableHasPagenation from '../../../components/TableHasPagenation'
import moment from 'moment'
import TransfersItemOperateInBtns from './TransfersItemOperateInBtns'
import TransfersItemOperateOutBtns from './TransfersItemOperateOutBtns'
import { FreshList } from '../context'
import {transfersOutStatusMap} from '../config'
import TransfersLogInfo from './TransfersLogInfo'
import {useState} from "react";
import {Button, Form, Input, Modal, Space, message} from "antd";
import TransfersDetail from './TransfersDetail'
import service from "../../../@services";
import {ExclamationCircleOutlined} from "@ant-design/icons";
const { confirm } = Modal;
export default function TransfersListTable({
  pageData,
  getList,
  loading,
  rowSelection,
  allocationType,
})
{
  const [updateModalVisible, setUpdateRecordVisible] = useState(false)
  const [$confirmLoading, set$confirmLoading] = useState(false)
  const [visible, setVisibile] = useState(false)
  const [no, setNo] = useState('');
  const [way, setWay] =useState('');
  const [detail, setDetail] = useState({});
  const getLog = (no, way)=>{
    setNo(no)
    setWay(way)
    setUpdateRecordVisible(true)
  }
  const BasicColumns = [
    {
      title: '序号',
      dataIndex: 'id',
      render: (t, r, index) =>
        (pageData.pageIndex - 1) * pageData.pageSize + index + 1
    },
    {
      title: '调拨单据',
      dataIndex: 'no'
    },
    {
      title: '调出门店',
      dataIndex: 'sourceStoreName'
    },
    {
      title: '调入门店',
      dataIndex: 'destStoreName'
    },
    {
      title: '状态',
      dataIndex: 'status',
      render: text => transfersOutStatusMap[text]
    },
    {
      title: '品类',
      dataIndex: 'kindCount'
    },
    {
      title: `调${allocationType =='in'?'入':'出'}总量`,
      dataIndex: 'productTotal'
    },
    {
      title: `调${allocationType =='in'?'入':'出'}总额`,
      dataIndex: 'totalAmount'
    },
    {
      title: '经手人',
      dataIndex: 'handlerName'
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      render: val => moment(val).format('YYYY-MM-DD HH:mm')
    },
    {
      title: '备注',
      dataIndex: 'note',
      ellipsis: true,
      render: (text, record) => (allocationType === 'out'? record.note: record.inwardNote)
    },
    {
      title: '操作',
      width: '240px',
      render: (text, record, index) => (
         allocationType === 'out'? <TransfersItemOperateInBtns
          getList={getList}
          getLog= {getLog}
          record={record}
        />: <TransfersItemOperateOutBtns
          getLog= {getLog}
          getList={getList}
          getInWarehouse={ getInWarehouse }
          record={record}
        />
      )
    }
  ]
  const fresh = () => getList(pageData)
  const [form] = Form.useForm()
  const getInWarehouse = async (no) =>{
    setNo(no)
    const _detail = await service.inventory.allocationDetail(no)
    _detail && setDetail(_detail)
    form.setFieldsValue({inwardNote: ''})
    setVisibile(true);
  }
  const onInWarehouseNo =  async ()=>{
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '请确认调拨单明细，确认收货后系统自动入库',
      okText: '确认',
      cancelText: '取消',
      onOk: async ()=>{
        set$confirmLoading(true)
        try {
          const data = await service.inventory.allocationInWarehouseNo({...form.getFieldsValue(),no: detail.no})
          set$confirmLoading(false)
          setVisibile(false)
          message.success('操作成功')
          getList()
        }catch (e){
          set$confirmLoading(false)
        }
      }
    })
  }
  const footer = (
    <Space style={{ textAlign: 'right' }}>
      <Button type='primary' onClick={onInWarehouseNo} loading={$confirmLoading}>
        确认收货
      </Button>
      <Button onClick={()=>setVisibile(false)}>取消</Button>
    </Space>
  )

  return (
    <FreshList.Provider value={{ fresh }}>
      <TableHasPagenation
        columns={BasicColumns}
        rowKey='id'
        onPageSizeChange={getList}
        pageData={pageData}
        rowSelection={rowSelection}
        loading={loading}
      />
      <TransfersLogInfo visible={updateModalVisible} no={no} way={way} close={()=>{setUpdateRecordVisible(false)}}></TransfersLogInfo>

      <Modal
        confirmLoading={$confirmLoading}
        visible={visible}
        width={1000}
        title="操作入库"
        onCancel={()=>setVisibile(false)}
        footer={footer}
      >
        <TransfersDetail detail={detail} identifier='in-warehouse'/>
        <Form form={form}>
          <Form.Item
            name='inwardNote'
            label='备注'
            rules={[
              { max: 50, message: '备注不超过50个字符', type: 'string' }
            ]}>
            <Input.TextArea placeholder='请输入备注' />
          </Form.Item>
        </Form>
      </Modal>
    </FreshList.Provider>
  )
}
